import {ItemsList} from "../../components/item-list";
import {usePortfolioData} from "../../data";
import {MediaCarousel} from "../../components/media-carousel";
import {Certification} from "../../../../data/model/certification";
import {LinkIcon} from "lucide-react";
import {ListItem} from "../../../../components/list-item";
import {SimpleLogo} from "../../components/simple-logo";

export function CertificationsSubpage () {
    const { certifications } = usePortfolioData();

    const regularPriorityCertifications = certifications.filter(c => c.priority !== "low");
    const lowPriorityCertifications = certifications.filter(c => c.priority === "low");

    return <div className={"flex flex-col items-center max-w-2xl gap-12 animate-in fade-in duration-300 slide-in-from-bottom-2"}>
        <ItemsList spacing={"compact"}>
            { regularPriorityCertifications.map((certification, index) => {
                return <CertificationItem key={index} certification={certification}/>
            })}
        </ItemsList>
        <ItemsList spacing={"compact"} cols={2}>
            { lowPriorityCertifications.map((certification, index) => {
                return <CertificationItem key={index} certification={certification}/>
            })}
        </ItemsList>
    </div>
}

function CertificationItem ({certification, size}: { certification: Certification, size?: "sm" }) {
    return <div className={"p-4"}>
        <ListItem>
            <ListItem.Logo>
                <SimpleLogo logo={certification.logo}/>
            </ListItem.Logo>
            <ListItem.Header>
                <h3>{certification.title}</h3>
            </ListItem.Header>
            <ListItem.Description>
                <div className={"flex flex-col gap-2"}>
                    { certification.description && <p className={"text-sm text-muted-foreground whitespace-pre-wrap"}>{ certification.description }</p> }
                    { certification.score && <CertificationScore score={certification.score} /> }
                    { certification.links && <div className={"flex flex-row flex-wrap items-center gap-x-4 gap-y-1"}>
                        { certification.links.map((link, index) => (
                            <a key={index} href={link.url} target={"_blank"} className={"py-1 group text-sm text-primary hover:underline flex flex-row items-center gap-1"}>
                                <LinkIcon className={"w-3.5 h-3.5 transition-all group-hover:translate-x-0.5"} />
                                <div className={"group-hover:translate-x-1 transition-all duration-300"}>{ link.label }</div>
                            </a>
                        )) }
                    </div>}
                    <MediaCarousel media={certification.media} className={"mt-2"}/>
                </div>
            </ListItem.Description>
        </ListItem>
    </div>
}

function CertificationScore ({ score } : { score: Exclude<Certification["score"], undefined> }) {
    return <div className={"bg-accent rounded-md px-2 py-1 flex flex-row flex-wrap items-center gap-1 self-start"}>
        <div className={"flex flex-row items-center"}>
            <div className={"text-muted-foreground"}>Score:&nbsp;</div>
            <div className={"text-foreground font-medium"}>{ score.value }</div>
            { score.maxScore && <div className={"font-medium opacity-65"}>/ { score.maxScore }</div> }
        </div>
        { score.percentile && <div className={"text-sm text-muted-foreground"}>({ score.percentile } percentile)</div> }
    </div>
}